import { render } from "./DealersHp.vue?vue&type=template&id=4603f892"
import script from "./DealersHp.vue?vue&type=script&lang=js"
export * from "./DealersHp.vue?vue&type=script&lang=js"

import "./DealersHp.vue?vue&type=style&index=0&id=4603f892&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__